const $inject = ['$log', 'appInsightsService', 'APP_CONFIG'];

const exceptionHandler = function($log, appInsightsService, APP_CONFIG) {
  return function errorCatcherHandler(exception, cause) {
    $log.error(exception);

    if(APP_CONFIG.appInsights.enabled) {
      appInsightsService.trackError(exception);
    }
  };
};

exceptionHandler.$inject = $inject;

export default exceptionHandler;



// WEBPACK FOOTER //
// ./src/factories/exceptionHandler.js